import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Spinner } from 'reactstrap';

import PremiumEventCard from '../Card/PremiumEventCard';
import EventCard from '../Card/EventCard';

import Amplify, { Auth, API, Hub } from 'aws-amplify';
import config from '../../aws-exports'
import { UserContext } from '../../components/UserContext'
// import { ScoreContext } from '../components/ScoreContext'
import Lottie from 'react-lottie';
import batchImg from '../../assets/images/events-banner.png';
import { default as animationData } from '../../assets/loader.json';
import {
  withAuthenticator,
  AmplifySignOut,
  ForgotPassword
} from "aws-amplify-react";
import { cx } from '@emotion/css';
import * as styles from '../events.style.js';

import MathematicsPracticeEventImage from '../../assets/images/Mathematics_practiceevent.png';
Amplify.configure(config)

// Function to check premium status
const checkPremiumStatus = async () => {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const session = await Auth.currentSession();
    const jwt = session.getIdToken().getJwtToken();
    const username = user.username.includes("Google_")
      ? user.attributes.email
      : user.username;

    // Check subscription status with timeout
    const res = await fetch("https://api.prod.quizwizard.net/quiz/getSubscription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt,
      },
      body: JSON.stringify({ username }),
    });

    const data = await res.json();

    // Check both subscription status and premium user flag
    const isPremium = data.status === "active" || user.attributes['custom:premiumuser'] === '1';

    return {
      isPremium,
      isLoading: false,
      error: null
    };
  } catch (error) {
    console.error("Error checking premium status:", error);
    return {
      isPremium: false,
      isLoading: false,
      error: error
    };
  }
};
function PremCatScreen(props) {
  const [events_category, set_events_category] = useState([]);
  const { user, setUser } = useContext(UserContext);
  const [grade_user, set_grade_user] = useState(0);
  const [premiumlevel, set_premiumlevel] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [premiumCheckError, setPremiumCheckError] = useState(null);
  const [isPremium, setIsPremium] = useState(false);
  const [loadedcategories, set_loadedcategories] = useState(false);

  //  const {score,setScore} = useContext(ScoreContext);

  ////console.log("Calling EventCatScreen.....")

  // Check premium status when component mounts or auth state changes
  useEffect(() => {
    document.title = 'Premium Categories';

    const checkPremiumAccess = async () => {
      try {
        const { isPremium, error } = await checkPremiumStatus();
        if (error) throw error;

        setIsPremium(isPremium);
        setPremiumCheckError(null);

        // Only load content if user is premium
        if (isPremium) {
          getToken();
        }
      } catch (error) {
        console.error('Error checking premium status:', error);
        setPremiumCheckError('Failed to verify subscription status');
      } finally {
        setIsLoading(false);
      }
    };

    // Listen for auth events
    const authListener = Hub.listen('auth', ({ payload: { event } }) => {
      if (event === 'signIn' || event === 'signOut') {
        checkPremiumAccess();
      }
    });

    // Initial check
    checkPremiumAccess();

    // Cleanup listener
    return () => {
      Hub.remove('auth', authListener);
    };
  }, []);

  const getuserDetails = async (username, jwt) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: jwt },
      body: JSON.stringify({ username: username }),
    };
    const response = await fetch(
      `https://api.prod.quizwizard.net/quiz/getuser`,
      requestOptions
    );
    const data = await response.json();
    // console.log(data)
    //set_userdetails(data)
    // setUser(data)
    //set_grade_user(5)

    set_grade_user(data['grade']);
    set_premiumlevel(data['premiumuser'])

    set_events_category([
      // { "id": 1, "category": "SpellBowl", "title": "SpellBowl", "count": 1, "username": username, "totalquestions": 20, "time": 400, grade: data['grade'], premium: data['premiumuser'] },
      { "id": 2, "category": "Revision", "title": "Mistakes Review", "count": 1, "username": username, "totalquestions": 20, "time": 400, grade: data['grade'], premium: data['premiumuser'] },
      // { "id": 3, "category": "HyphenSpaceChallenge", "title": "Hyphen & Space Challenge", "count": 1, "username": username, "totalquestions": 20, "time": 400, grade: data['grade'], premium: data['premiumuser'] },
      // { "id": 4, "category": "UppercaseChallenge", "title": "Uppercase Challenge", "count": 1, "username": username, "totalquestions": 20, "time": 400, grade: data['grade'], premium: data['premiumuser'] }
    ])
    set_loadedcategories(true)

  }


  const getToken = async () => {
    let user = null;
    try {
      user = await Auth.currentAuthenticatedUser();


      Auth.currentSession().then((res) => {

        let username = ""
        let accessToken = res.getAccessToken();
        let jwt = accessToken.getJwtToken();

        if (user.username.includes("Google_")) {

          username = user.attributes['email']






        }
        else {

          username = user.username



        }
        getuserDetails(username, jwt)






      });




    } catch (error) {
      //console.log(error)
      Auth.signOut()
    }
  };




  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  let event_category_Cards = events_category.map(eventcategory => {
    // Determine the target route based on the category
    let target = "premiumquiz";
    if (eventcategory.category === 'HyphenSpaceChallenge') {
      target = 'hyphen-space-challenge';
    } else if (eventcategory.category === 'UppercaseChallenge') {
      target = 'uppercase-challenge';
    }

    return (
      <div key={eventcategory.id} className="col-md-4">
        <Col className="py-2 border rounded" key={eventcategory.id}>
          <PremiumEventCard
            imgsrc={MathematicsPracticeEventImage}
            title={eventcategory.title}
            time="500"
            key={eventcategory.id}
            eventcategory={eventcategory}
            target={target}
          />
        </Col>
      </div>
    )
  })

  // Handler for Mistake Quiz Card
  const [loadingMistakeQuiz, setLoadingMistakeQuiz] = useState(false);
  const handleMistakeQuiz = async () => {
    setLoadingMistakeQuiz(true);

    try {
      // Get username from context or localStorage
      let username;
      if (user && user.username && user.username.includes("Google_")) {
        username = user.attributes['email'];
      } else if (user && user.username) {
        username = user.username;
      } else {
        username = localStorage.getItem('username');
      }
      console.log("Username sent to lambda: ", username);
      // Direct fetch to new API Gateway endpoint
      const response = await fetch('https://api.prod.quizwizard.net/quiz/getUserMistakes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username }),
      });
      const data = await response.json();
      // data.incorrect_words is expected to be an array of words
      const mistakes = data.incorrect_words || [];
      if (mistakes.length === 0) {
        alert('No mistakes found!');
        setLoadingMistakeQuiz(false);
        return;
      }
      // Create a new quiz event with these questions
      if (props.createQuizEvent) {
        props.createQuizEvent({ questions: mistakes, type: 'mistakeQuiz' });
      } else {
        alert('Quiz event creation function not found.');
      }
    } catch (err) {
      console.error('Error fetching mistakes:', err);
      alert('Failed to create quiz from mistakes.');
    }
    setLoadingMistakeQuiz(false);
  };

  // Add the Quiz from Mistakes card to the event cards array
  const mistakeEventCard = (
    <div key="mistake-quiz" className="col-md-4">
      <Col className="py-2 border rounded" onClick={handleMistakeQuiz} style={{ cursor: 'pointer', opacity: loadingMistakeQuiz ? 0.5 : 1 }}>
        <PremiumEventCard
          imgsrc={'/assets/quiz.jpg'}
          title="Quiz from Mistakes"
          time="--"
          eventcategory={{ category: 'Mistakes', id: 'mistake-quiz' }}
          target="mistakequiz"
        />
        {loadingMistakeQuiz && <span>Loading...</span>}
      </Col>
    </div>
  );
  // Prepend the mistake card to the event cards
  const allEventCards = [...event_category_Cards];

  // Show loading state
  if (isLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
        <p className="mt-3">Verifying your subscription...</p>
      </div>
    );
  }

  // Show error state
  if (premiumCheckError) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-warning">
          <h4>Subscription Status Unavailable</h4>
          <p className="mb-3">{premiumCheckError}</p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  // Show premium required message
  if (!isPremium) {
    return (
      <div className="container mt-5">
        <div className="alert alert-warning text-center">
          <div className="mb-3">
            <i className="bi bi-star-fill text-warning" style={{ fontSize: '2.5rem' }}></i>
          </div>
          <h3>Premium Access Required</h3>
          <p className="mb-4">This section requires an active premium subscription.</p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.href = '/subscription'}
          >
            <i className="bi bi-arrow-up-circle me-2"></i>Upgrade to Premium
          </button>
        </div>
      </div>
    );
  }

  // Show premium content
  return (
    <div>
      <div className={cx(styles.batchBanner)}>
        <img src={batchImg} alt="" />
      </div>
      <div className={cx(styles.batchTitle)}>Premium Quiz Events</div>
      <div className={cx(styles.cardEventsFluid)}>
        {loadedcategories ? (
          <Row>{allEventCards}</Row>
        ) : (
          <div className="welcomecenter">
            <Lottie options={defaultOptions} height={400} width={400} />
            <p>Loading premium content...</p>
          </div>
        )}
      </div>
    </div>
  )
}
export default PremCatScreen;